<template>
    <v-sheet class="fuera-de-servicio" color="secondary" tile>
        <div class="aviso text-center">
            <!-- Como <img> y no en línea: las animaciones del SVG funcionan igual
            y sus ids no chocan con los de otras ilustraciones -->
            <img class="ilustracion" src="@/assets/fuera-de-servicio.svg" alt="" />
            <h2 class="mt-4">Sistema fuera de servicio</h2>
            <p class="mt-4 mb-0">
                En este momento no es posible conectarse con el Sistema de Prácticas.
                Intente nuevamente en unos minutos.
            </p>
            <v-btn class="mt-6" color="primary" :loading="verificando" @click="verificar">
                Reintentar
            </v-btn>
        </div>
    </v-sheet>
</template>

<script>
import { saludService } from "@/services";

const INTERVALO_REINTENTO_MS = 15000;

// Consulta el backend cada cierto tiempo y emite "restablecido" cuando vuelve
// a responder; qué hacer entonces lo decide quien lo muestra.
export default {
    data: () => ({
        verificando: false,
        intervalo: null,
    }),
    mounted() {
        this.intervalo = setInterval(this.verificar, INTERVALO_REINTENTO_MS);
    },
    beforeDestroy() {
        clearInterval(this.intervalo);
    },
    methods: {
        verificar() {
            if (this.verificando) {
                return;
            }
            this.verificando = true;
            saludService.backendDisponible().then(disponible => {
                this.verificando = false;
                if (disponible) {
                    this.$emit("restablecido");
                }
            });
        },
    },
};
</script>

<style scoped>
.fuera-de-servicio {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}
.aviso {
    max-width: 480px;
}
.ilustracion {
    width: 100%;
    max-width: 360px;
}
</style>
